import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./Settings.module.css"
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs from "../../app/lang/langs";
import { InputSwitch } from "primereact/inputswitch";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputText } from "primereact/inputtext";
import editIcon from '../../assets/images/edit.png'
import editIconFocus from '../../assets/images/editFocus.png'
import xIcon from "../../assets/images/reject.png";
import xIconFocus from "../../assets/images/rejectDanger.png";
import checkIcon from "../../assets/images/check.png";
import checkIconFocus from "../../assets/images/checkSuccess.png"
import AddSkillModal from "./Modals/AddSkillModal";
import { addEditSkill, getSkillsSettings, removeSkill } from "../../components/clients/clientsSlice";

export default function SkillsTab() {

    const dispatch = useDispatch()

    const skillsSlice = useSelector((state) => state.clients.skills)


    const [skills, setSkills] = useState([]);
    const [addModalVisible, setAddModalVisible] = useState(false)
    const [onEditSkill, setOnEditSkill] = useState(null)
    const [onEditName, setOnEditName] = useState('')

    const mounted = useRef(null);

    useEffect(() => { setSkills(skillsSlice) }, [skillsSlice])

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
        dispatch(getSkillsSettings())
    }, [mounted]);

    const handleActivateSkill = (e, rowData) => {
        if (e.value === true) {
            setSkills(
                skills.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 1,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditSkill({ id: rowData.id, active: 1 })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getSkillsSettings());
                    showSuccessToast("Compétence activé")
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        };
        if (e.value === false) {
            setSkills(
                skills.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 0,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditSkill({ id: rowData.id, active: 0 })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getSkillsSettings());
                    showErrorToast("Compétence désactivé")
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        };
    }

    const toggleActive = (rowData) => {
        return (
            <div className="d-flex justify-content-start">
                <InputSwitch
                    checked={rowData.active == 1}
                    onChange={(e) => { handleActivateSkill(e, rowData); }}
                />
            </div>
        )
    }
    const deleteButton = (rowData) => {
        return (
            <ImageButton
                image={deleteIcon}
                imageFocus={deleteIconFocus}
                onClick={() => { confirmDelete(rowData.id, rowData.name) }}
                active={true}
                tooltip={<Langs str="DELETE_SKILL" />}
                width={24} />
        )
    }
    const confirmDelete = (id, name) => {
        const accept = () => {
            dispatch(removeSkill({ id: id })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getSkillsSettings());
                    showSuccessToast(responseData.message)
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        }

        const reject = () => {
            return
        }
        const message = (name) => {
            return <p className="my-2"><Langs str="DELETE_SKILL_MESSAGE" /> <b>{name}</b></p>
        }
        confirmDialog({
            message: message(name),
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };
    const tableHeader = () => {
        return (
            <div>
                <ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => { setAddModalVisible(true) }}
                    active={true}
                    tooltip={<Langs str="ADD_SKILL" />}
                    width={24} />
            </div>
        )
    }

    const handleEditSkill = (name, id) => {
        if (name.trim() != '' && id != null) {
            dispatch(addEditSkill({ id: id, name: name }))
            setSkills(current => {
                return current.map(skill => {
                    if (skill.id == id) {
                        return {
                            ...skill,
                            name: name
                        };
                    }
                    return skill;
                });
            });
            setOnEditSkill(null);
            setOnEditName('')
        }
    }

    const editField = () => {
        return (
            <div>
                <InputText value={onEditName} onChange={(e) => setOnEditName(e.target.value)} />
                <ImageButton
                    image={xIcon}
                    imageFocus={xIconFocus}
                    onClick={() => { setOnEditSkill(null); setOnEditName('') }}
                    active={true}
                    tooltip={<Langs str="CANCEL" />}
                    width={18}
                />
                {onEditName.trim() != '' &&
                    <ImageButton
                        image={checkIcon}
                        imageFocus={checkIconFocus}
                        onClick={() => { handleEditSkill(onEditName, onEditSkill) }}
                        active={true}
                        tooltip={<Langs str="EDIT_CLIENT" />}
                        width={28}
                    />}
            </div>
        )
    }
    const bodyColumn = (rowData) => {
        return (
            <div className="d-flex justify-content-between">
                {rowData.id == onEditSkill ? editField(rowData.name, rowData.id) : rowData.name}
                <ImageButton
                    image={editIcon}
                    imageFocus={editIconFocus}
                    onClick={() => { setOnEditSkill(rowData.id); setOnEditName(rowData.name) }}
                    active={true}
                    tooltip={<Langs str="EDIT" />}
                    width={20}
                />
            </div>
        )
    }

    return (
        <div>
            <Row className="m-0">
                <Col xl={1}>
                </Col>
                <Col xl={8} className="d-flex align-content-center">
                    <div className={styles.menuContent}>
                        <DataTable
                            value={skills}
                            scrollable
                            scrollHeight="calc(85vh)"
                            draggable={false}
                            paginator 
                            rows={10} 
                            rowsPerPageOptions={[10, 30, 50]}
                        >
                            <Column field="active" header={<Langs str="ACTIVE" />} body={toggleActive} ></Column>
                            <Column field="name" sortable body={bodyColumn} header={<Langs str="NAME" />} ></Column>
                            <Column field="id" header={tableHeader} body={deleteButton}></Column>
                        </DataTable>
                    </div>
                </Col>
            </Row>

            <AddSkillModal
                visible={addModalVisible}
                setVisible={setAddModalVisible}
            />
        </div>
    )
}